export const SCHEMA_NAME = "CivilPapersJudgment";

export const FIELDS = {
  CIVIL_PAPERS_JUDGMENT_ID: "civilPapersJudgmentID",
  CIVIL_PAPER_ID: "civilPaperID",
  JUDGMENT: "judgment",
  JUDGMENT_DATE: "judgmentDate",
  INTEREST_RATE: "interestRate",
  SECOND_FEE: "2ndFee",
  TOTAL_JUDGMENT: "totalJudgment",
  JUDGMENT_COMMENTS: "judgmentComments",
  COMMISSION: "commission",
};
